'use strict';
import angular from 'angular';
import ngMessages from 'angular-messages';
import ngMaterial from 'angular-material';
import GeneralInfoEditController from './general-info-edit.controller';
import GeneralInfoEditService from './general-info-edit.service';
import AddressForm from '../address';
import UserService from '../../../auth/user.service';
export default angular.module('directives.generalInfoEditForm', [ngMessages, ngMaterial, AddressForm])
    .service('UserService', UserService)
    .service('GeneralInfoEditService', GeneralInfoEditService)
    .component('generalInfoEditForm', {
    template: require('./general-edit.html'),
    controller: GeneralInfoEditController,
    controllerAs: 'ge',
    bindings: {
        user: '<',
        mode: '=',
        audience: '<',
        onUpdate: '&',
        changeAccountInfo: '<'
    }
})
    .name;
//# sourceMappingURL=index.js.map